<script>

    import { toast } from 'bulma-toast'
    import { replace } from 'svelte-spa-router'

    import { UserStore } from '../stores'

    import UsersService from '../$services/users.service'

    import Button from '../$components/button.svelte'
    import Form from '../$components/form.svelte'
    import Image from '../$components/image.svelte'
    import InputEmail from '../$components/input.email.svelte'
    import InputPassword from '../$components/input.password.svelte'
    import InputPhone from '../$components/input.phone.svelte'
    import InputText from '../$components/input.text.svelte'

    let loading = false
    let password = ''
    let data = {role: 'user'}

    async function signup() {

        if(password != data.password)
            return toast({message: "Las contraseñas no coinciden", type: 'is-danger'})

        loading = true
        const resp = await UsersService.signup(data)
        loading = false

        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})

        UserStore.set(resp.data)

        toast({message: 'Registro completado, activa tu cuenta e inicia sesón', type: 'is-success'})
    }

</script>

{#if !$UserStore}
    <Form on:submit={ signup } hideCancel={true} isDivider={false} {loading} >

        <div class="items center">
            <Image src="/images/brand.png" size="128x128" />
        </div>
        <hr>
        <div class="columns">
            <div class="column">
                <InputText bind:value={data.firstName} placeholder='Nombre' label='Nombre' />
            </div>
        </div>
        <div class="columns">
            <div class="column">
                <InputText bind:value={data.lastName} placeholder='Apellidos' label="Apellidos"/>        
            </div>
        </div>
        <div class="columns">
            <div class="column">
                <InputPhone bind:value={data.phone} placeholder='Telefono' label='Telefono' required={false} />
            </div>
        </div>
        <div class="columns">
            <div class="column">
                <InputEmail bind:value={data.email} label="Email"/>
            </div>
        </div>
        <div class="columns">
            <div class="column">
                <InputPassword bind:value={data.password} label='Contraseña'/>
            </div>
            <div class="column">
                <InputPassword bind:value={password} label='Confirmar contraseña'/>
            </div>
        </div>
        <hr>
    </Form>

    <div class="space top">
        <Button on:click={() => replace('#/login')} text="Ya tengo una cuenta" icon="user" color="info" fullwidth={true} inverted={true} />
    </div>
{:else}
    <div class="items center">
        <Image src="/images/brand.png" size="128x128" />
    </div>
    <hr>

    <div class="columns">
        <div class="column">
            <article class="message is-warning">
                <div class="message-body">
                    Por favor revisa tu bandeja de entrada o spam para poder activar tu cuenta 
                </div>
            </article>   
        </div>
    </div>
{/if}